export const AFFILIATE_TRACKERS_CONDITION_ROUTE_NAME = Symbol('affiliate.trackers.condition');

export const AFFILIATE_TRACKERS_CONDITION_GET_URL = 'affiliate/trackers/:id/show_condition';
export const AFFILIATE_TRACKERS_CONDITION_GET_QUERY_KEY = 'affiliate.trackers.condition.get';
